import Route from '@ember/routing/route';

export default class ScansListRoute extends Route {
  model() {
    return this.modelFor('scans');
  }
}
